<template>
  <ts-radio-group
    :value="outputFormat"
    @radio-selected="$emit('change', $event.detail.value)"
  >
    <ts-radio value="side-by-side" label="Show changes side by side"></ts-radio>
    <ts-radio value="line-by-line" label="Show changes inline"></ts-radio>
  </ts-radio-group>
</template>

<script>
import '@tradeshift/elements.radio';
import '@tradeshift/elements.radio-group';

export default {
  props: {
    outputFormat: {
      type: String,
      default: 'side-by-side',
    },
  },
  emits: ['change'],
};
</script>
